/**
 * @author: Matthew Rawson @ 08/09/2017 14:06
 * @notes: This column needs to explicitly override canvas elements generated inside it. This is used for displaying
 * QR codes, the lib I am using requires the qr size prop to be a number, so I can't pass a string through.
 */
import styled from "styled-components"

export default styled.div`
  text-align: center;

  canvas {
    width: 100% !important;
    height: 100% !important;
    max-width: 120px;
  }
`
